import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form, Icon, Input } from 'semantic-ui-react'
import ProjectActions from 'Redux/ProjectRedux'

class AddProject extends Component {
  constructor () {
    super()
    this.state = {
      newProjectName: ''
    }
  }

  componentDidUpdate (prevProps) {
    if (this.props.createData !== prevProps.createData) {
      this.props.history.push('/projects/' + this.props.createData.id)
    }
  }

  handleChange = (e) => {
    this.setState({ newProjectName: e.target.value })
  }

  onAdd = () => {
    const lowerCaseName = this.state.newProjectName.toLowerCase().trim()
    const titleExists = this.props.projects.some(proj => {
      return proj.title.toLowerCase().trim() === lowerCaseName
    })

    if (!titleExists && this.state.newProjectName) {
      this.props.projectsCreateRequest({
        title: this.state.newProjectName,
        teamId: this.props.teamId
      })
      this.setState({ newProjectName: '' })
    }
  }

  render () {
    if (!this.props.shown) return null
    return (
      <Form style={{ margin: '10px' }}>
        <Form.Field style={{display: 'none'}}>
          <Form.Button
            style={{display: 'none'}}
            onClick={this.onAdd}>
              Submit
          </Form.Button>
        </Form.Field>
        <Form.Field>
          <Input
            autoFocus
            focus={true}
            loading={this.props.fetching}
            icon={
              <Icon
                name='plus'
                link
                onClick={this.onAdd}
              />}
            placeholder='Enter project name'
            onChange={this.handleChange}
            value={this.state.newProjectName}
          />
        </Form.Field>
      </Form>
    )
  }
}

const mapStateToProps = (state) => ({
  fetching: state.projects.createFetching,
  error: state.projects.createError,
  projects: state.projects.listData,
  createData: state.projects.createData
})

const mapDispatchToProps = (dispatch) => ({
  projectsCreateRequest: (params) =>
    dispatch(ProjectActions.projectsCreateRequest(params))
})

export default connect(mapStateToProps, mapDispatchToProps)(AddProject)



// WEBPACK FOOTER //
// ./src/Components/AddProject.js